const IconClose = ({ className }) => {
    return (
        <svg
            width='22'
            height='22'
            viewBox='0 0 22 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4.8372 4.97783C5.18785 4.62718 5.75636 4.62718 6.10701 4.97783L10.8594 9.73025L15.6119 4.97783C15.9625 4.62718 16.531 4.62718 16.8817 4.97783C17.2323 5.32848 17.2323 5.89699 16.8817 6.24763L12.1292 11.0001L16.8817 15.7525C17.2323 16.1031 17.2323 16.6716 16.8817 17.0223C16.531 17.3729 15.9625 17.3729 15.6119 17.0223L10.8594 12.2699L6.10701 17.0223C5.75636 17.3729 5.18785 17.3729 4.8372 17.0223C4.48656 16.6716 4.48656 16.1031 4.8372 15.7525L9.58963 11.0001L4.8372 6.24763C4.48656 5.89699 4.48656 5.32848 4.8372 4.97783Z'
            />
        </svg>
    );
};

export default IconClose;
